<template>
  <div class="container">
    <div class="section-wrapper top-wrapper">
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="username" :placeholder="$t('Enter Phone Number')" type="number"
            :attr="{ oninput: 'if(value.length>11)value=value.slice(0,11)' }" />
        </div>
      </flex-line>
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" v-model="code" :placeholder="$t('Enter SMS Verification Code')" type="number"
            :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
          <div @click="sendVerifyCodeMobile" class="common-btn send-btn">{{ sendStateTextMobile }}</div>
        </div>
      </flex-line>
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" type="password" v-model="password" :placeholder="$t('Set Password')" />
        </div>
      </flex-line>
      <flex-line class="field-line input-wrapper" :show-border="true">
        <div class="field-line-right" slot="right">
          <input class="field-input" type="password" v-model="confirmPassword" :placeholder="$t('Confirm Password')" />
          <label v-if="!confirmPassword" class="tips">{{ $t('6-20 digits/letters/symbols') }}</label>
        </div>
      </flex-line>
    </div>
    <div class="common-btn ds-button-large mt-10 mb-10" @click="onSubmit">{{ $t('Sign Up') }}</div>
    <div class="link-wrapper">
      <input class="isagree" type="checkbox" v-model="isagree" />
      <span class="left-text">{{ $t('By clicking sign up, you agree to') }}</span>
      <span class="right-text" @click="onAgreement">{{ $t('User Agreement') }}</span>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { mapState, mapMutations } from 'vuex'
import { registerByMobile } from '../../../api/memberRegister'
import { getSmsCaptcha } from '../../../api/common'
import flexLine from '../../flexLine'
export default {
  name: 'RegisterByMobile',
  data() {
    return {
      username: '',
      code: '',
      password: '',
      isagree: false,
      confirmPassword: '',
      aggrementUrl: '',
      verifyCodeMobile: '',
      canSendMobile: true,
      timeIntervalMobile: false,
      sendStateTextMobile: this.$t('send'),
    }
  },
  components: {
    flexLine
  },
  mounted() {

  },
  created: function () {

  },
  computed: {
    ...mapState({
      inviter_id: state => state.member.inviterId
    })
  },

  beforeDestroy: function () {
    clearInterval(this.timeIntervalMobile)
  },
  methods: {
    ...mapMutations({
      saveAuthInfo: 'memberLogin'
    }),
    goBack() {
      this.$router.go(-1)
    },
    goProfile() {
      this.$router.go(-2)
    },
    goProfileAdd() {
      this.$router.push({ name: 'profileAdd' })
    },

    sendVerifyCodeMobile() {
      if (!this.username) {
        Toast(this.$t('Please enter your phone number'))
        return
      }
      if (!this.canSendMobile) {
        return
      }
      getSmsCaptcha(1, this.username).then(res => {
        this.canSendMobile = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.timeIntervalMobile = setInterval(function () {
          if (second <= 0) {
            _this.canSendMobile = true
            _this.sendStateTextMobile = this.$t('send')
            clearInterval(_this.timeIntervalMobile)
          } else {
            _this.sendStateTextMobile = second + 's'
          }
          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    check() {
      let username = this.username;
      let code = this.code;
      let password = this.password;
      let confirmPassword = this.confirmPassword;

      if (this.isagree === false) {
        Toast(this.$t('Please check the user agreement'));
        return false;
      }
      if (username.length === 0) {
        Toast(this.$t('Please enter your phone number'));
        return false;
      }
      if (code.length === 0) {
        Toast(this.$t('Please enter the verification code'));
        return false;
      }
      if (code.length !== 6) {
        Toast(this.$t('Please enter a 6-digit verification code'));
        return false;
      }
      if (password.length === 0) {
        Toast(this.$t('Please enter a password'));
        return false;
      }
      if (password.length < 6 || password.length > 20) {
        Toast(this.$t('Please enter a password with 6-20 characters'));
        return false;
      }
      if (confirmPassword.length === 0) {
        Toast(this.$t('Please enter the confirm password'));
        return false;
      }
      if (password.length !== confirmPassword.length) {
        Toast(this.$t('The confirm password does not match the entered password'));
        return false;
      }
      if (password !== confirmPassword) {
        Toast(this.$t('The confirm password does not match the entered password'));
        return false;
      }
      return true;
    },
    signup() {
      if (!this.check()) {
        return
      }
      Indicator.open()
      let inviterId = this.inviter_id // 获取邀请人id

      registerByMobile(this.username, this.password, this.confirmPassword, this.code, inviterId).then(
        response => {
          Indicator.close()
          this.saveAuthInfo({ token: response.result.token, info: response.result.info })
          this.$router.push({ name: 'MemberIndex' })
        },
        error => {
          Indicator.close()
          Toast(error.message)
        }
      )
    },
    onSubmit() {
      this.signup()
    },
    onAgreement() {
      this.$router.push({
        name: 'HomeDocument',
        query: { type: '' }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.ds-button-large {
  margin: 0 $pageSpace
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

  //background-color: $primaryColor;
  .input-wrapper {
    font-size: $subFontSize;
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    align-items: center;
    background-color: #fff;
    height: 2.2rem;
    padding-left: 0.5rem;

    input {
      flex: 1;
    }

    .bottom-input {
      border-bottom-width: 0;
    }

    img {
      height: 1.75rem
    }
  }

  .link-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;

    span {
      font-size: $subFontSize;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .left-text {
      color: $descTextColor;
    }

    .right-text {
      color: $primaryColor;
    }
  }
}

.top-wrapper {
  margin: 0 $pageSpace;
}

.bottom-wrapper {
  margin-top: 0.5rem;
}

.tips {
  color: $descTextColor;
  font-size: $fontSize;
  white-space: nowrap;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -.3rem;
}

.countdown {
  min-width: 4rem;
  margin-right: 0.5rem;
}

.send-btn {
  border: 1px solid $primaryColor;
  color: $primaryColor;
  min-width: 2rem
}

.field-line-right {
  position: relative
}

.field-input {
  text-align: left !important;
}

.isagree {
  width: .8rem;
  height: .8rem;
}
</style>
